import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'zv-info-flag',
  template: `<span class="zv-info-flag__wrapper" [class]="colorClass()">{{ text() }}</span>`,
  styleUrl: './info-flag.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class ZvInfoFlagComponent {
  public readonly text = input.required<string>();
  public readonly bgColor = input.required<InfoFlagColor>();
  public readonly colorClass = computed(() => {
    return `zv-info-flag__color-${this.bgColor()}`;
  });
}

export type InfoFlagColor = 'turquoise' | 'green' | 'blue' | 'orange' | 'grey' | 'red';
